const common = {
  site_name: 'h漫画',
  site_description: '精选成人漫画在线阅读平台',
  nav_home: '首页',
  nav_category: '分类',
  nav_about: '关于我们',
  nav_hot: '热门推荐',
  nav_latest: '最新更新',
  read_more: '阅读更多',
  view_all: '查看全部',
  home: '首页',
  loading: '加载中...',
  error: '加载失败',
  retry: '重试',
  no_data: '暂无数据',
  scroll_top: '回到顶部',
  copyright: '© 2026 h漫画 版权所有',
  privacy: '隐私政策',
  terms: '服务条款',
  contact: '联系我们',
};

export default common;